import React from "react";
import BaseComponent from "../../../BaseComponent.js";
import styled from "styled-components";

import NanoFlex from "../../../Global/NanoFlex.js";
import WrapperList from "../../../Nano/WrapperList.js";
import TitleCard from "../../../Nano/TitleCard.js";
import Article from "../../../Nano/Article.js";

const StyledEvaluationBlock = styled(NanoFlex)`
  .noBorderWrapper {
    border: none;
    padding: 0;
  }
  .titleWrapper {
    h5 {
      width: 100%;
    }
  }
`;

export class EvaluationBlock extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    if (!this.props.card.evaluation || this.props.card.evaluation.trim() === "") return null;

    return (
      <StyledEvaluationBlock className="rowContainer evaluationBlock">
        <WrapperList simple className="noBorderWrapper">
          <TitleCard simpleTitle={this.translation.card.evaluation} />
          <Article article={this.props.card.evaluation} />
        </WrapperList>
      </StyledEvaluationBlock>
    );
  }
}

//Set default props
EvaluationBlock.defaultProps = {
  card: {},
};

export default EvaluationBlock;

// --- // Documentation // --- //
/*
  import EvaluationBlock from './../Partial/EvaluationBlock.js';
  
  <EvaluationBlock/>
  */
